import Constants from 'expo-constants';
import { isWeb, platformOS } from '@/lib/platform';

const DEFAULT_API_TIMEOUT_MS = 40000;
const DEFAULT_ADMIN_API_TIMEOUT_MS = 20000;
const DEFAULT_AUTH_BOOT_TIMEOUT_MS = 3000;

type RuntimeConfig = {
  apiUrl?: string;
  apiTimeoutMs?: number;
  adminApiTimeoutMs?: number;
  authBootstrapTimeoutMs?: number;
  enableEmailAuth?: boolean;
  enableGoogleAuth?: boolean;
  enableDatadog?: boolean;
  datadogEnv?: string;
  bootDiagnosticsEnabled?: boolean;
};

function getApiUrl(): string {
  if (
    isWeb &&
    typeof window !== 'undefined' &&
    (window.location.hostname === 'pickempickem.com' || window.location.hostname === 'www.pickempickem.com')
  ) {
    return window.location.origin;
  }

  return process.env.EXPO_PUBLIC_API_URL || runtimeConfig.apiUrl || 'http://saf-pc.tail1431bd.ts.net:5001';
}

function parseNumberFlag(value: any, fallback: number): number {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim().length > 0) {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  return fallback;
}

function parseBooleanFlag(value: any, fallback = false): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase());
  }
  return fallback;
}

function parseTimeoutMsFlag(value: any, fallback: number): number {
  const parsed = parseNumberFlag(value, fallback);
  if (parsed > 0) {
    return parsed;
  }
  return fallback;
}

const runtimeConfig = (Constants.expoConfig?.extra?.runtime ?? {}) as RuntimeConfig;

export const config = {
  apiUrl: getApiUrl(),
  platform: platformOS,
  apiTimeoutMs: parseTimeoutMsFlag(
    runtimeConfig.apiTimeoutMs,
    DEFAULT_API_TIMEOUT_MS,
  ),
  adminApiTimeoutMs: parseNumberFlag(runtimeConfig.adminApiTimeoutMs, DEFAULT_ADMIN_API_TIMEOUT_MS),
  authBootstrapTimeoutMs: parseNumberFlag(runtimeConfig.authBootstrapTimeoutMs, DEFAULT_AUTH_BOOT_TIMEOUT_MS),
  auth: {
    emailPasswordEnabled: parseBooleanFlag(runtimeConfig.enableEmailAuth, true),
  },
  socialAuth: {
    googleEnabled: parseBooleanFlag(runtimeConfig.enableGoogleAuth, true),
  },
  datadogEnabled: parseBooleanFlag(
    process.env.EXPO_PUBLIC_ENABLE_DATADOG,
    parseBooleanFlag(runtimeConfig.enableDatadog, true),
  ),
  datadogEnv: runtimeConfig.datadogEnv || 'dev',
  bootDiagnosticsEnabled: parseBooleanFlag(runtimeConfig.bootDiagnosticsEnabled, false),
} as const;
